export class LoginInfo {
    username: string;
    password: string;
}

export class LoginModel {
    loginInfo: LoginInfo;
    forceLogin: boolean = false;
    returnUrl: string = '';
}
